module.exports = __webpack_public_path__ + "static/media/sidenav-icon-users.322354ca.svg";